import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { userHistory } from "../../api/directory";
import { HistoryPanel } from "./HistoryPanel";

// Collapsible change log for an employee: click to expand, filter by period.
export const EmployeeHistory = ({ userId }) => {
  const { t } = useTranslation();
  const loader = useCallback(
    () => userHistory(userId).then((r) => r.items || []),
    [userId]
  );
  return (
    <HistoryPanel
      title={t("detail.history.title")}
      hint={t("detail.history.hint")}
      emptyLabel={t("detail.history.empty")}
      loader={loader}
      rowNs="detail.history"
      testId="employee-history"
    />
  );
};
